import { render, staticRenderFns } from "./RiskCheckDailySafetyChecklistAlwaysDetail.vue?vue&type=template&id=15c4e566&scoped=true&"
import script from "./RiskCheckDailySafetyChecklistAlwaysDetail.vue?vue&type=script&lang=js&"
export * from "./RiskCheckDailySafetyChecklistAlwaysDetail.vue?vue&type=script&lang=js&"
import style0 from "./RiskCheckDailySafetyChecklistAlwaysDetail.vue?vue&type=style&index=0&id=15c4e566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4e566",
  null
  
)

export default component.exports